/*
 * partners.js - category filtering for the integration partners wall.
 *
 * Progressive enhancement only. The server renders one continuous grid of every active partner -
 * the wall exactly as it was before groups existed - and the filter bar is rendered `hidden`.
 * This script reveals it. So with JavaScript off there are no dead controls and no missing
 * partners: you get the original unbroken wall, which is the correct fallback rather than a
 * degraded one.
 *
 * Filtering only ever HIDES chips. It never reorders them, because the server has already laid
 * them out group by group; reshuffling on every click would make the wall feel unstable.
 *
 * Nothing here fetches. Every partner is already in the DOM, so filtering is instant and works
 * offline once the page has loaded.
 */

const bar = document.getElementById('partner-filters');
const wall = document.getElementById('partner-wall');
const count = document.getElementById('partner-count');

if (bar && wall) {
  const chips = [...wall.querySelectorAll('.logo-chip')];
  const buttons = [...bar.querySelectorAll('.filt')];

  // Only now that the behaviour is known to work do the controls appear.
  bar.hidden = false;
  if (count) {
    count.hidden = false;
  }

  const describe = (shown, filter) =>
    filter === '*'
      ? `Showing all ${shown} partners`
      : `Showing ${shown} ${shown === 1 ? 'partner' : 'partners'} in ${filter}`;

  const apply = (filter) => {
    let shown = 0;

    for (const chip of chips) {
      const match = filter === '*' || chip.dataset.group === filter;

      // `hidden` rather than a class: it removes the chip from the accessibility tree as well as
      // the grid, so a screen reader is never offered a logo that is not on screen.
      chip.hidden = !match;

      if (match) {
        shown++;
      }
    }

    for (const button of buttons) {
      const on = button.dataset.filter === filter;
      button.classList.toggle('is-on', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    if (count) {
      // aria-live on the element means this is announced. Without it, a filter click would change
      // the page silently for anyone not looking at it.
      count.textContent = describe(shown, filter);
    }
  };

  bar.addEventListener('click', (event) => {
    const button = event.target.closest('.filt');

    if (button && bar.contains(button)) {
      apply(button.dataset.filter ?? '*');
    }
  });

  apply('*');
}
